export const contactManagementVersion = '9.3.1';
